import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import { HashRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { AlertProvider } from "./context/AlertContext";
import { ServerStatusProvider } from "./context/ServerStatusProvider";
import { store } from "./store";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { trTR } from "@mui/material/locale";

// HashRouter kullandığımız için /davet?token=x gibi hash'siz deep-link'leri
// /#/davet?token=x formatına çeviriyoruz (eski e-posta linkleri dahil).
(function redirectToHash() {
  const { pathname, search, hash } = window.location;
  if (pathname !== "/" && !hash) {
    window.location.replace("/" + "#" + pathname + search);
  }
})();

const el = document.getElementById("root");
const root = ReactDOM.createRoot(el);
const theme = createTheme({}, trTR);

// Service worker YALNIZCA production build'de kaydedilir.
//
// Development'ta CRA bundle'ı sabit adla servis eder (/static/js/bundle.js) ve
// sw.js bu yolu CACHE-FIRST tutuyor — dosya adı hiç değişmediği için tarayıcı
// sonsuza dek eski bundle'ı gösteriyordu; hard refresh bile kurtarmıyordu
// (Safari'de gözlemlendi). Production'da sorun yok: dosya adları içerik
// hash'li (main.<hash>.js), yeni build yeni ad üretir.
//
// Ayrıca dev'de daha önce kaydolmuş bir SW varsa TEMİZLENİR — aksi halde bu
// düzeltmeyi alan geliştirici hâlâ eski SW'nin esiri kalırdı.
if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    });
  } else {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
    if (window.caches?.keys) {
      caches
        .keys()
        .then((keys) => keys.forEach((k) => caches.delete(k)))
        .catch(() => {});
    }
  }
}

root.render(
  <React.StrictMode>
    <HashRouter>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
              <AuthProvider>
                <ServerStatusProvider>
                  <AlertProvider>
                    <Routes>
                      <Route path="/*" element={<App />} />
                    </Routes>
                  </AlertProvider>
                </ServerStatusProvider>
              </AuthProvider>
        </Provider>
      </ThemeProvider>
    </HashRouter>
  </React.StrictMode>
);
